export const Payment = {
    fromVideo: (video) => {
        return {
            title: video.title,
            cost: video.cost,
            requires_payment: video.requires_payment,
            image: video.image
        }
    },
    fromDirectory: (directory) => {
        return {
            title: directory.name,
            cost: directory.cost,
            requires_payment: directory.requires_payment,
            image: directory.image
        }
    }
}